// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","right":"App_right__TxKjn","left":"App_left__yierV"};